import DatabaseModel from './DatabaseModel.js';
import { unwrapDto } from './responseUtils.js';

var Inspector = Object.create(DatabaseModel);

Inspector.model = 'inspector';

// GET /movilidad/inspector/{username}/servicios-huerfanos
// → { username, nombre, codigo, existeFicha, totalServicios, huerfanos[], repetidos[] }
// Los códigos de la lista de servicios de la ficha que no corresponden a ningún servicio del
// catálogo (#329). Solo lectura: no toca la ficha.
// Sin caché a propósito: lo que contesta depende del catálogo y de la ficha, y las dos cosas se
// editan desde la propia aplicación; servir la respuesta anterior diría que ya no hay huérfanos
// —o que sigue habiéndolos— sin haberlo mirado.
Inspector.serviciosHuerfanos = function(username) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + encodeURIComponent(username) + '/servicios-huerfanos',
        method: 'GET'
    }, false).then(unwrapDto);
};

// El mismo recuento para todas las fichas de una vez está en
// `GET /movilidad/inspector/servicios-huerfanos`, y no se envuelve aquí a propósito: no lo consume
// ninguna pantalla todavía, porque la vista conjunta necesitaría una ruta nueva en el menú
// efectivo del usuario, que es dato y no código (§9 del CLAUDE.md del orquestador).

export default Inspector;
